<template>
    <div>

        <div>
            <TheHeader/>
        </div>

        <div class="pt-40 text-lg w-1/2 m-auto">
            <h1>404</h1>
            <p>Page Not Found</p>
            <p>seems the page you are looking for cannot be found</p>
            <p>Go back <router-link to="/">Home</router-link></p>
        </div>
        
    </div>
</template>

<script>
import TheHeader from './layout/TheHeader.vue'
export default {
    components: {
        TheHeader
    }
}
</script>